import { render, staticRenderFns } from "./AppointmentAdvisorsList.vue?vue&type=template&id=8c966104"
import script from "./AppointmentAdvisorsList.vue?vue&type=script&lang=ts"
export * from "./AppointmentAdvisorsList.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentAdvisorsList.vue?vue&type=style&index=0&id=8c966104&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports